import { useCallback, useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getSiteHeaderState } from '../../SiteHeader/redux/selectors';
import { EditorContext } from '../context';
import { useEditorDraftActions } from './useEditorDraftActions';
/**
 * Makes sure our draft states are updated before a window unloads
 *
 * Relies on our {@link EditorContext}.
 */ export function useEditorDraftUnmountEffects(editorId) {
    const { state } = useContext(EditorContext);
    const { saveEditorDraft, removeEditorDraft } = useEditorDraftActions(editorId);
    const isLoggingOut = useSelector((reduxState)=>getSiteHeaderState(reduxState).isLoggingOut);
    const handleBeforeUnload = useCallback(()=>{
        var _state_isEmpty;
        const isEmpty = (_state_isEmpty = state === null || state === void 0 ? void 0 : state.isEmpty) !== null && _state_isEmpty !== void 0 ? _state_isEmpty : true;
        if (isLoggingOut) {
            // On logout we have a specific saga that clears all drafts
            return;
        } else if (!isEmpty && state) {
            saveEditorDraft(state);
        } else if (state) {
            removeEditorDraft();
        }
    }, [
        state,
        isLoggingOut,
        saveEditorDraft,
        removeEditorDraft
    ]);
    // beforeunload instead of purely doing on unmount so
    // that page navigation also triggers a draft removal/save
    useEffect(()=>{
        if (typeof window !== 'undefined') {
            window.addEventListener('beforeunload', handleBeforeUnload);
        }
        return ()=>{
            if (typeof window !== 'undefined') {
                window.removeEventListener('beforeunload', handleBeforeUnload);
            }
        };
    }, [
        handleBeforeUnload
    ]);
}
